// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1203":"5c2775eb7d9d636a","5852":"9bcb07f1bd3d2af9"}[chunkId] + ".css";
};